import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";
import { BsClockHistory, BsFileText } from "react-icons/bs";

const ReviewStatusDistribution = ({ taskAnalytics = {} }) => {
  const series = [
    Number(taskAnalytics?.totalPendingTask || 0),
    Number(taskAnalytics?.totalPassedTask || 0),
    Number(taskAnalytics?.totalFailedTask || 0),
  ];

  const total = series.reduce((a, b) => a + b, 0);

  const reviewedPercentage =
    total > 0
      ? Math.round(
        ((taskAnalytics?.totalPassedTask || 0) / total) * 100
      )
      : 0;

  const chartOptions = {
    chart: {
      type: "donut",
    },
    colors: ["#f59e0b", "#22c55e", "#ef4444"],
    labels: [
      "Pending Task",
      "Passed Task",
      "Failed Task",
    ],
    stroke: {
      width: 0,
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "72%",
          labels: {
            show: true,
            value: {
              show: true,
              fontSize: "15px",
              fontWeight: 700,
              formatter: () => `${reviewedPercentage}%`,
            },
            total: {
              show: true,
              label: "COMPLETE",
              fontSize: "10px",
              fontWeight: 600,
              color: "#64748b",
            },
          },
        },
      },
    },
  };

  const statusData = [
    {
      name: "Pending Task",
      value: Number(taskAnalytics?.totalPendingTask || 0),
      color: "#f59e0b",
    },
    {
      name: "Passed Task",
      value: Number(taskAnalytics?.totalPassedTask || 0),
      color: "#22c55e",
    },
    {
      name: "Failed Task",
      value: Number(taskAnalytics?.totalFailedTask || 0),
      color: "#ef4444",
    }
  ];

  return (
    <div className="app-card shadow-md border br3 bg-light h-100">
      <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
        <Form.Label className="m-0 text-nowrap bold">
          <BsFileText className="me-2 text-info" />
          Review Status Distribution
        </Form.Label>

        <small className="text-secondary">
          {total} Tasks
        </small>
      </div>

      <div className="p-2 hstack gap-4 w-100">
        <Chart
          options={chartOptions}
          series={series}
          type="donut"
          height={150}
        />

        <div className="w-100">
          {statusData.map((item) => (
            <div
              key={item.name}
              className="hstack justify-content-between mb-1 w-100"
            >
              <div className="hstack">
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: item.color,
                    display: "inline-block",
                    marginRight: 12,
                  }}
                />
                <small style={{ fontSize: 13 }}>
                  {item.name}
                </small>
              </div>

              <div className="hstack gap-2">
                <small className="fw-bold">
                  {item.value}
                </small>

                <small className="text-secondary">
                  {total > 0
                    ? Math.round((item.value / total) * 100)
                    : 0}
                  %
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewStatusDistribution;